import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\AuthController::notice
 * @see app/Http/Controllers/AuthController.php:884
 * @route '/reauthenticate'
 */
export const notice = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: notice.url(options),
    method: 'get',
})

notice.definition = {
    methods: ["get","head"],
    url: '/reauthenticate',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthController::notice
 * @see app/Http/Controllers/AuthController.php:884
 * @route '/reauthenticate'
 */
notice.url = (options?: RouteQueryOptions) => {
    return notice.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::notice
 * @see app/Http/Controllers/AuthController.php:884
 * @route '/reauthenticate'
 */
notice.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: notice.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AuthController::notice
 * @see app/Http/Controllers/AuthController.php:884
 * @route '/reauthenticate'
 */
notice.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: notice.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\AuthController::notice
 * @see app/Http/Controllers/AuthController.php:884
 * @route '/reauthenticate'
 */
    const noticeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: notice.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\AuthController::notice
 * @see app/Http/Controllers/AuthController.php:884
 * @route '/reauthenticate'
 */
        noticeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: notice.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\AuthController::notice
 * @see app/Http/Controllers/AuthController.php:884
 * @route '/reauthenticate'
 */
        noticeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: notice.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    notice.form = noticeForm
/**
* @see \App\Http\Controllers\AuthController::methods
 * @see app/Http/Controllers/AuthController.php:714
 * @route '/reauthenticate/methods'
 */
export const methods = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: methods.url(options),
    method: 'get',
})

methods.definition = {
    methods: ["get","head"],
    url: '/reauthenticate/methods',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthController::methods
 * @see app/Http/Controllers/AuthController.php:714
 * @route '/reauthenticate/methods'
 */
methods.url = (options?: RouteQueryOptions) => {
    return methods.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::methods
 * @see app/Http/Controllers/AuthController.php:714
 * @route '/reauthenticate/methods'
 */
methods.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: methods.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AuthController::methods
 * @see app/Http/Controllers/AuthController.php:714
 * @route '/reauthenticate/methods'
 */
methods.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: methods.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\AuthController::methods
 * @see app/Http/Controllers/AuthController.php:714
 * @route '/reauthenticate/methods'
 */
    const methodsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: methods.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\AuthController::methods
 * @see app/Http/Controllers/AuthController.php:714
 * @route '/reauthenticate/methods'
 */
        methodsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: methods.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\AuthController::methods
 * @see app/Http/Controllers/AuthController.php:714
 * @route '/reauthenticate/methods'
 */
        methodsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: methods.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    methods.form = methodsForm
/**
* @see \App\Http\Controllers\AuthController::requestCode
 * @see app/Http/Controllers/AuthController.php:742
 * @route '/reauthenticate/{method}/code'
 */
export const requestCode = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: requestCode.url(args, options),
    method: 'get',
})

requestCode.definition = {
    methods: ["get","head"],
    url: '/reauthenticate/{method}/code',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthController::requestCode
 * @see app/Http/Controllers/AuthController.php:742
 * @route '/reauthenticate/{method}/code'
 */
requestCode.url = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { method: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    method: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        method: args.method,
                }

    return requestCode.definition.url
            .replace('{method}', parsedArgs.method.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::requestCode
 * @see app/Http/Controllers/AuthController.php:742
 * @route '/reauthenticate/{method}/code'
 */
requestCode.get = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: requestCode.url(args, options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AuthController::requestCode
 * @see app/Http/Controllers/AuthController.php:742
 * @route '/reauthenticate/{method}/code'
 */
requestCode.head = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: requestCode.url(args, options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\AuthController::requestCode
 * @see app/Http/Controllers/AuthController.php:742
 * @route '/reauthenticate/{method}/code'
 */
    const requestCodeForm = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: requestCode.url(args, options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\AuthController::requestCode
 * @see app/Http/Controllers/AuthController.php:742
 * @route '/reauthenticate/{method}/code'
 */
        requestCodeForm.get = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: requestCode.url(args, options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\AuthController::requestCode
 * @see app/Http/Controllers/AuthController.php:742
 * @route '/reauthenticate/{method}/code'
 */
        requestCodeForm.head = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: requestCode.url(args, {
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    requestCode.form = requestCodeForm
/**
* @see \App\Http\Controllers\AuthController::verifyCode
 * @see app/Http/Controllers/AuthController.php:804
 * @route '/reauthenticate/{method}/code'
 */
export const verifyCode = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verifyCode.url(args, options),
    method: 'post',
})

verifyCode.definition = {
    methods: ["post"],
    url: '/reauthenticate/{method}/code',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::verifyCode
 * @see app/Http/Controllers/AuthController.php:804
 * @route '/reauthenticate/{method}/code'
 */
verifyCode.url = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { method: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    method: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        method: args.method,
                }

    return verifyCode.definition.url
            .replace('{method}', parsedArgs.method.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::verifyCode
 * @see app/Http/Controllers/AuthController.php:804
 * @route '/reauthenticate/{method}/code'
 */
verifyCode.post = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verifyCode.url(args, options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthController::verifyCode
 * @see app/Http/Controllers/AuthController.php:804
 * @route '/reauthenticate/{method}/code'
 */
    const verifyCodeForm = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: verifyCode.url(args, options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthController::verifyCode
 * @see app/Http/Controllers/AuthController.php:804
 * @route '/reauthenticate/{method}/code'
 */
        verifyCodeForm.post = (args: { method: string | number } | [method: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: verifyCode.url(args, options),
            method: 'post',
        })
    
    verifyCode.form = verifyCodeForm
const reauthenticate = {
    methods: Object.assign(methods, methods),
requestCode: Object.assign(requestCode, requestCode),
verifyCode: Object.assign(verifyCode, verifyCode),
}

export default reauthenticate